import {
  MylistFormType,
  MylistGetType,
  MylistsGetType
} from '../../validation/mylist/mylistType';
import { csrfToken, instance } from '../db';
import { AxiosResponse } from 'axios';

// マイリスト取得API
export const getMylistInfo = async (
  mylistId: number,
  offset: number,
  order: number,
  method: number
): Promise<MylistGetType> => {
  const response = await instance.get(
    `/mylist/${mylistId}?offset=${offset}&order=${order}&method=${method}`,
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response.data;
};

// マイリスト追加API
export const addMylist = async (productId: number): Promise<AxiosResponse> => {
  const response = await instance.post(
    '/mylist',
    { product_id: productId },
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response;
};

// マイリスト削除API
export const deleteMylistProduct = async (
  productId: number,
  mylistId?: number
): Promise<AxiosResponse> => {
  const data: { product_id: { id: number }[]; mylist_id?: number } = {
    product_id: [{ id: productId }]
  };

  if (mylistId !== undefined) {
    data.mylist_id = mylistId;
  }
  const response = await instance.delete(`/mylist`, {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    },
    data: data
  });
  return response;
};

// マイリスト一括削除API
export const deleteMylistAll = async (
  productIds: { id: number }[],
  mylistId: number
): Promise<AxiosResponse> => {
  const response = await instance.delete(`/mylist`, {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    },
    data: { product_id: productIds, mylist_id: mylistId }
  });
  return response;
};

// マイリスト一覧取得API
export const getMylists = async (
  limit: number,
  offset: number
): Promise<MylistsGetType> => {
  const response = await instance.get(
    `/mylists?limit=${limit}&offset=${offset}`,
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response.data;
};

// マイリスト作成API
export const createMylist = async (
  watch: (fieldName: string) => MylistFormType
): Promise<AxiosResponse> => {
  const response = await instance.post(
    '/mylists',
    {
      title: watch('title'),
      remarks_first: watch('remarks1'),
      remarks_second: watch('remarks2')
    },
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response;
};

export const updateMylist = async (
  mylistId: number,
  watch: (fieldName: string) => MylistFormType
): Promise<AxiosResponse> => {
  const response = await instance.put(
    `/mylists/${mylistId}`,
    {
      title: watch('title'),
      remarks_first: watch('remarks1'),
      remarks_second: watch('remarks2')
    },
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response;
};

export const copyMylist = async (
  mylistId: number,
  watch: (fieldName: string) => MylistFormType
): Promise<AxiosResponse> => {
  const response = await instance.post(
    `/mylists`,
    {
      title: watch('title'),
      remarks_first: watch('remarks1'),
      remarks_second: watch('remarks2'),
      mylist_id: mylistId
    },
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response;
};

export const deleteMylist = async (
  mylistId: number
): Promise<AxiosResponse> => {
  const response = await instance.delete(`/mylists/${mylistId}`, {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    }
  });
  return response;
};

export const changeUseMylist = async (
  mylistId: number
): Promise<AxiosResponse> => {
  const response = await instance.put(
    `/mylists/${mylistId}/patern_change`,
    {},
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response;
};
